module.exports = __webpack_public_path__ + "static/img/bus.42c1ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus.jpg
// module id = EfZw
// module chunks = 0